import { rootApi } from "../../api/rootApi";

export const ecommerceHeirarchyApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchEcommerceHeirarchy: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/ecommerce/heirarchy`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),

    fetchEcommerceSubcategories: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/ecommerce/heirarchy/subcategories`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    addEcommerceHeirarchy: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/ecommerce/heirarchy/add`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    bulkAddEcommerceHeirarchy: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/ecommerce/heirarchy/bulk-insert`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    updateEcommerceHeirarchyById: builder.mutation({
      query: (params) => {
        return {
          method: "PUT",
          url: `/tenant/ecommerce/heirarchy/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    deletedEcommerceHeirarchyById: builder.mutation({
      query: (params) => {
        return {
          method: "DELETE",
          url: `/tenant/ecommerce/heirarchy/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
  }),
});

export const {
  useFetchEcommerceHeirarchyMutation,
  useFetchEcommerceSubcategoriesMutation,
  useAddEcommerceHeirarchyMutation,
  useBulkAddEcommerceHeirarchyMutation,
  useUpdateEcommerceHeirarchyByIdMutation,
  useDeletedEcommerceHeirarchyByIdMutation,
} = ecommerceHeirarchyApi;
